import React from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { useFormById } from '@shared/components/EventForm/components/data/hooks/useFormById';
import { FormType } from '@graphql/generated';

const getFormLink = (formId: string, eventId: string, isRegistration?: boolean) => {
  return `${window?.location.origin}/${eventId}/${isRegistration ? 'registration' : 'form'}/${formId}`;
};

type FormLinkButtonProps = {
  formId: string;
  eventId: string;
  ctaText?: string;
};

export const FormLinkButton = (props: FormLinkButtonProps) => {
  const { formId, eventId, ctaText } = props;
  const { data, loading } = useFormById(formId);

  if (!formId) {
    return null;
  }

  const isRegistration = data?.type === FormType.REGISTRATION;

  const formLink = getFormLink(formId, eventId, isRegistration);

  return (
    <ButtonV2
      as="a"
      href={formLink}
      disabled={loading}
    >
      {ctaText ?? 'Open Form'}
    </ButtonV2>
  );
};
